import { Injectable } from '@angular/core';
import { AppConstants } from '../enums/global-enum-constant';
import { WbidApiService } from './wbid-api.service';
import { Router } from '@angular/router';
 
@Injectable({ providedIn: 'root' })
export class AppInitService {
 
  constructor(private ApiService: WbidApiService,private router: Router) {}
 
  initApp(): Promise<void> {
   
    const fromApp = { FromApp: AppConstants.AppNum };
    // const isLoaded = sessionStorage.getItem("activePage") != 'login' ? true : false;
     const activePage = sessionStorage?.getItem("activePage") || "";
    const isLoaded = ["bidline", "home"].includes(activePage);
     if (isLoaded) {
      return Promise.resolve();
    }
 
    return this.GetApplicationLoadDatas(fromApp)
      .toPromise()  
      .then((res: any) => {
        if (res?.IsSWAAPI) {
          localStorage.setItem('isSecretSwitchforSwAapi', 'true');
        } else {
          localStorage.removeItem('isSecretSwitchforSwAapi');
        }
      })
      .catch(err => {
        console.error('App init failed', err);
        return Promise.resolve();
      });
  }
 
  public GetApplicationLoadDatas(FromApp: any) {
    try {
       return this.ApiService.GetRestDataForPost(
        "User/GetApplicationLoadDatas",
        FromApp
      );
    } catch (error) {
      throw `ClassName:VersionManagementService, FunctionName: GetApplicationLoadDatas,
        ErrorMessage: ${error.stack.toString()}`;
    }
  }
}
 
 